<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()" [hovered]="hovered">
    <fui-fixtures>
        <fui-fixture *ngIf="icon">
            <ng-content select="fui-icon"></ng-content>
        </fui-fixture>
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <input (blur)="onBlur($event)" [disabled]="disabled" (focus)="onFocus($event)" #input
                       (keypress)="keypress($event)" [(ngModel)]="query" [placeholder]="placeholder | translate"
                       [tabindex]="tabindex" type="text">
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture>
            <fui-mark-button (click)="remove()">
                <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
            </fui-mark-button>
        </fui-fixture>
    </fui-fixtures>
</fui-pill-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop()">
    <fui-sections>
        <fui-content-section *ngIf="loading">
            <fui-loading>
                <fui-ellipsis-loader></fui-ellipsis-loader>
            </fui-loading>
        </fui-content-section>
        <fui-content-section *ngIf="empty(options)">
            <fui-empty>
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </fui-content-section>
        <fui-section *ngIf="filled(options)">
            <fui-autocomplete-options [field]="field" [key]="key" [options]="options"
                                (selection$)="select($event)"></fui-autocomplete-options>
        </fui-section>
    </fui-sections>
</fui-select-pop>
